
export const FriButtonIcon = () => {
    return <img  style={{width:"3rem"}} src={"/fri-media/fri-button.png"}></img>;
};